import _createOrderHardware from "@fuze/apis-foundry/dist/orders/functions/createOrderHardware"

import { wrapFoundryFunctionWithOrganization } from "./decorators"

export const createOrderHardware = wrapFoundryFunctionWithOrganization(_createOrderHardware)
